import Attachment from './Attachment'
import {useState, useEffect} from 'react'
import { useDispatch,useSelector } from 'react-redux';
import myOrderOperations from 'redux/MyOrder/operations';
import myOrderSelectors from 'redux/MyOrder/selectors';

const AttachmentContainer = () => {
    const [attachmentBtnText, setAttachmentBtnText] = useState('Attachments (0)');
    const [attachmentBtnClicked, setAttachmentBtnClicked] = useState(false);
    const [uploadClickId, setUploadClickId] = useState<any>('');
    const [uploadErrMsg, setUploadErrMsg] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch();

    const dispatchSetOrderDetails = myOrderOperations.dispatchSetOrderDetails(dispatch);

    const {
        orderDetails,
        isUploadComplete,
        BlobUrlListObj
      } :any = useSelector(
        (state: any) => ({
          orderDetails: myOrderSelectors.orderDetails(state),
          isUploadComplete : myOrderSelectors.isUploadComplete(state),
          BlobUrlListObj: myOrderSelectors.BlobUrlListObj(state),
        })
      )

    const handleAttachmentClick = () => {
        setAttachmentBtnClicked(!attachmentBtnClicked);
    }

    const onCancelAttachment = () => {
        setUploadErrMsg([])
        setAttachmentBtnClicked(false);
    }

  useEffect(()=>{
      if(isUploadComplete){
        let BtnText =  `Attachments (${orderDetails?.attachmentFileObjList?.length ?? 0})`;
        setAttachmentBtnText(BtnText)
      }
  },[orderDetails?.attachmentFileObjList,isUploadComplete])

useEffect(()=>{
    if(BlobUrlListObj.hasOwnProperty('id')){
      if(BlobUrlListObj?.BlobUrlList != undefined){
      orderDetails['attachmentUrlList']=BlobUrlListObj?.BlobUrlList;
      orderDetails['attachments'] = [];
      if (orderDetails?.attachmentFileObjList?.length) {
        orderDetails?.attachmentFileObjList?.forEach((x:any, i:any)=>{
          let fileInfo = {'fileName': '', 'mimeType' : '', 'attachmentUrl' : ''}
          fileInfo.fileName = x?.name;
          fileInfo.mimeType = x?.type;
          fileInfo.attachmentUrl = BlobUrlListObj?.BlobUrlList[i];
          orderDetails['attachments'].push(fileInfo);
        })
      }
      dispatchSetOrderDetails(orderDetails);
    }
  }
  },[JSON.stringify(BlobUrlListObj.BlobUrlList)]);

  useEffect(()=>{
    if(isUploadComplete){
      setIsLoading(false);
      let uploadErrArr = [...uploadErrMsg];
      uploadErrArr[uploadClickId] = ''
      setUploadErrMsg(uploadErrArr)

    }
  },[isUploadComplete])

  useEffect(()=>{
    setUploadClickId('')
  },[])

  return <Attachment attachmentBtnText={attachmentBtnText} isLoading={isLoading} attachmentBtnClicked={attachmentBtnClicked}
  handleAttachmentClick={handleAttachmentClick} onCancelAttachment={onCancelAttachment} setAttachmentBtnClicked={setAttachmentBtnClicked}
  setIsLoading={setIsLoading} setUploadErrMsg={setUploadErrMsg} uploadErrMsg={uploadErrMsg}/>
}

export default AttachmentContainer;